import { currenciesHash } from '@goeuro/app/client/fe-utils/src/Currency';

export interface Currency {
  code: string;
  symbol: string;
}

export const currencies: Currency[] = Object.keys(currenciesHash).map(code => ({
  code: currenciesHash[code].iso,
  symbol: currenciesHash[code].symbol,
}));

export const defaultCurrency: Currency = {
  code: 'eur',
  symbol: '€',
};

export const listCurrencyCodes = () => currencies.map(({ code }) => code);
